import { makeRequest } from '../../../lib/api';
import {
  PromoListRequestInterface,
  PromoCreateRequest,
  PromoUpdateRequest,
  ProjectPromoCreateRequest,
  ServicePromoCreateRequest,
  PartnerPromoCreateRequest,
} from '../api/promoReferenceApi';

import { CreateClientPromoRequest, UpdateClientPromoRequest } from '../api/promoApi.d';

const PROMOS_PATH = '/v1/promos';
const CLIENT_PROMOS_PATH = '/v1/client_promos';
const PROJECT_PROMOS_PATH = '/v1/project_promos';
const PARTNER_PROMOS_PATH = '/v1/partner_promos';
const SERVICE_PROMOS_PATH = '/v1/service_promos';

class promoController {
  getPromoList = (data: PromoListRequestInterface) => {
    const param = `showDeleted=${ data?.showDeleted }${
      data?.projectId ? `&projectId=${ data?.projectId }` : '' }`;
    return makeRequest('get', `${ PROMOS_PATH }?${ param }`);
  };

  createPromo = (data: PromoCreateRequest) => {
    return makeRequest('post', `${ PROMOS_PATH }`, data);
  };

  updatePromo = (data: PromoUpdateRequest) => {
    return makeRequest('put', `${ PROMOS_PATH }/${ data.id }`, data);
  };

  deletePromo = (id:string) => {
    return makeRequest('delete', `${ PROMOS_PATH }/${ id }`);
  };

  restorePromo = (id:string) => {
    return makeRequest('post', `${ PROMOS_PATH }/${ id }`);
  };

  // привязка к проектам
  getProjectPromoList = (promoId: string) => {
    return makeRequest('get', `${ PROJECT_PROMOS_PATH }?promoId=${ promoId }`);
  };

  createProjectPromo = (data: ProjectPromoCreateRequest) => {
    return makeRequest('post', `${ PROJECT_PROMOS_PATH }`, data);
  };

  deleteProjectPromo = (id:string) => {
    return makeRequest('delete', `${ PROJECT_PROMOS_PATH }/${ id }`);
  };
  // конец блока привязки к проектам

  // привязка к сервисам
  getServicePromoList = (promoId: string) => {
    return makeRequest('get', `${ SERVICE_PROMOS_PATH }?promoId=${ promoId }`);
  };

  createServicePromo = (data: ServicePromoCreateRequest) => {
    return makeRequest('post', `${ SERVICE_PROMOS_PATH }`, data);
  };

  deleteServicePromo = (id:string) => {
    return makeRequest('delete', `${ SERVICE_PROMOS_PATH }/${ id }`);
  };
    // конец блока привязки к сервисам

  // привязка к партнёрам
  getPartnerPromoList = (promoId: string) => {
    return makeRequest('get', `${ PARTNER_PROMOS_PATH }?promoId=${ promoId }`);
  };

  createPartnerPromo = (data: PartnerPromoCreateRequest) => {
    return makeRequest('post', `${ PARTNER_PROMOS_PATH }`, data);
  };

  deletePartnerPromo = (id:string) => {
    return makeRequest('delete', `${ PARTNER_PROMOS_PATH }/${ id }`);
  };
  // конец блока привязки к партнёрам

  // блок клиент-промо
  getClientPromoList = (clientId: string) => {
    return makeRequest('get', `${ CLIENT_PROMOS_PATH }?clientId=${ clientId }`);
  };

  createClientPromo = (data: CreateClientPromoRequest) => {
    return makeRequest('post', `${ CLIENT_PROMOS_PATH }`, data);
  };

  updateClientPromo = (id: string, data: UpdateClientPromoRequest) => {
    return makeRequest('put', `${ CLIENT_PROMOS_PATH }/${ id }`, data);
  };

  deleteClientPromo = (promoId:string) => {
    return makeRequest('delete', `${ CLIENT_PROMOS_PATH }/${ promoId }`);
  };

  restoreClientPromo = (promoId:string) => {
    return makeRequest('post', `${ CLIENT_PROMOS_PATH }/${ promoId }`);
  };
    // конец блока клиент-промо
}

export default new promoController();
